var map = {
	"./ambience.wav": 3998,
	"./birds.webm": 1355,
	"./bush.webm": 321,
	"./click.wav": 1946,
	"./crickets.webm": 3827,
	"./gacha_loop.wav": 8873,
	"./gacha_start.wav": 6269,
	"./gacha_stop.wav": 7731,
	"./harvest.wav": 1729,
	"./plant.wav": 701,
	"./plant_clicked.webm": 8128,
	"./sign.webm": 290,
	"./song.webm": 5254,
	"./thud.webm": 8522,
	"./wind.webm": 3469
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7217;